// See web/app/themes/jcf-theme/acf/video-carousel.twig

import "slick-carousel";
import Plyr from "plyr";
import $ from "jquery";

let iframe,
  player = [],
  $placeholder = [],
  $buttons = [],
  $videosCarousel = [],
  timer;

let setup = (index, element) => {
  iframe = element.querySelector(".embed");

  if (!iframe) {
    return;
  }
  player[index] = new Plyr(iframe);

  $placeholder[index] = $(element).find(".placeholder");

  player[index].on("ready", () => {
    $placeholder[index].on("click", function () {
      $(this).fadeOut("fast", function () {
        player[index].play();
      });
    });
  });
  player[index].on("playing", () => {
    $placeholder[index].fadeOut("fast");
  });
  player[index].on("pause", () => {
    // $placeholder[index].fadeIn('fast')
  });
};

let carousel = (idx, e) => {
  $buttons[idx] = $(e)
    .next(".video__carousel--navtext")
    .next(".video__carousel--nav")
    .find("[data-slide]");

  $videosCarousel[idx] = $(e)
    .on("beforeChange", function (_event, _slick, currentSlide) {
      if (player[currentSlide]) {
        // console.log(player[currentSlide]);
        clearTimeout(timer);
        player[currentSlide].pause();
      }
    })
    .on("init", function () {
      $buttons[idx].on("click", function (event) {
        // console.log(event);

        event.preventDefault();
        var slide = parseInt($(this).data("slide")) - 1;
        $videosCarousel[idx].slick("slickGoTo", slide);
        // player[slide].play()
        clearTimeout(timer);
        timer = setTimeout(() => player[slide].play(), 500);
      });
    })
    .on("afterChange", function (_event, _slick, currentSlide) {
      // player[currentSlide].play()
      $buttons[idx]
        .eq(currentSlide)
        .addClass("active")
        .siblings()
        .removeClass("active");
    })
    .slick({
      dots: false,
      arrows: false,
      mobileFirst: true,
      slidesToShow: 1,
      infinite: false,
      fade: true,
      swipe: false,
      waitForAnimate: false,
    });
};

class VideoResource {
  init() {
    $(document).ready(function () {
      $(".module .video").each(function (index, element) {
        setup(index, element);
      });

      $(".video__carousel").each(function (idx, el) {
        carousel(idx, el);
      });
    });
  }
}

export default VideoResource;
